import { View } from "binder"
import { ProductionStopList, ProductionStopListManipulationViewModel } from "./productionStopListManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ProductionStopListManipulationView extends View<ProductionStopListManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-2CF3EAE7-9754-4710-888B-1F54F1443AFB"
    }
    loadHtml(): string {
        let element = require('./productionStopListManipulation.html').default;
        let style = require('./productionStopListManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set productionStopLists(v: ProductionStopList) { this._productionStopLists = v; } public get productionStopLists(): ProductionStopList { return this._productionStopLists; } private _productionStopLists: ProductionStopList;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
